'use client';

import { ChevronRight } from 'lucide-react';
import { Button } from '@up2stay/up2promo-ui';

import {
  SettingsGroupRow,
  SettingsGroupRows,
} from '@/core/components/settings/settings-group';
import { SettingsInfoHint } from '@/core/components/settings/settings-info-hint';
import { SettingsSection } from '@/core/components/settings/settings-section';
import { useNavigateShell } from '@/core/hooks/use-navigate-shell';
import { shellPaths } from '@/core/router/app-paths';

interface UserManagementSectionProps {
  sectionId: string;
  dict: {
    title: string;
    description: string;
    manage: string;
    userManagement: string;
    userDescription: string;
    planInfo: string;
  };
}

export function UserManagementSection({
  sectionId,
  dict,
}: UserManagementSectionProps) {
  const { navigateShell } = useNavigateShell();

  const openPeople = () => {
    navigateShell(shellPaths.morePeople);
  };

  return (
    <SettingsSection
      id={sectionId}
      title={dict.title}
      footer={dict.planInfo}
      grouped
    >
      <SettingsGroupRows>
        <SettingsGroupRow>
          <div className="flex items-center justify-between gap-3">
            <div className="flex min-w-0 flex-1 items-center gap-0.5">
              <button
                type="button"
                className="truncate text-left font-medium"
                onClick={openPeople}
              >
                {dict.manage}
              </button>
              <SettingsInfoHint label={dict.manage}>
                {dict.userDescription}
              </SettingsInfoHint>
            </div>
            {/* Mouse/touch shortcut only: the text button above is the one
                control screen readers and the keyboard reach (DEV-540). */}
            <Button
              variant="ghost"
              size="icon"
              className="shrink-0 text-muted-foreground"
              aria-hidden
              tabIndex={-1}
              onClick={openPeople}
            >
              <ChevronRight className="h-4 w-4" aria-hidden />
            </Button>
          </div>
        </SettingsGroupRow>
      </SettingsGroupRows>
    </SettingsSection>
  );
}
